export type TAG_CATEGORY =
  | 'ON_WORK' //'출근'
  | 'OFF_WORK' //퇴근'
  | 'REST' // '휴식'
  | 'SELF_DEVELOPMENT' // 자기계발
  | 'WORKING_CULTURE' //'일하는 문화'
  | 'WELFARE_CULTURE' //복지 문화'
  | 'TEAM_CULTURE' //'팀 문화'
  | 'COMPANY_CULTURE'; //기업 문화'

export const TAG_CATEGORY_MAP: Record<TAG_CATEGORY, string> = {
  ON_WORK: '출근',
  OFF_WORK: '퇴근',
  REST: '휴식',
  SELF_DEVELOPMENT: '자기계발',
  WORKING_CULTURE: '일하는 문화',
  WELFARE_CULTURE: '복지 문화',
  TEAM_CULTURE: '팀 문화',
  COMPANY_CULTURE: '기업 문화',
};

export type salaryType =
  | 'UNDER_THIRTY_MILLION' //'3000만원 이하'
  | 'BETWEEN_THIRTY_AND_FORTY_MILLION' // '3000 ~ 4000만원'
  | 'BETWEEN_FORTY_AND_FIFTY_MILLION' //'4000 ~ 5000만원'
  | 'OVER_FIFTY_MILLION'; //5000만원 이상

export type locationType =
  | 'SEOUL' // '서울특별시', //"서울"
  | 'BUSAN' // '부산광역시',// "부산"
  | 'DAEGU' // '대구광역시', //"대구"
  | 'INCHEON' // '인천광역시',// "인천"
  | 'GWANGJU' // '광주광역시',// "광주"
  | 'DAEJEON' // '대전광역시',// "대전"
  | 'ULSAN' //'울산광역시', //"울산"
  | 'SEJONG' // '세종특별자치시',// "세종"
  | 'GYEONGGI' // '경기도', //"경기"
  | 'GANGWON' // '강원도', //"강원"
  | 'CHUNGBUK' // '충청북도', //"충북"
  | 'CHUNGNAM' // '충청남도', //"충남"
  | 'JEONBUK' // '전라북도', //"전북"
  | 'JEONNAM' // '전라남도', //"전남"
  | 'GYEONGBUK' // '경상북도', //"경북"
  | 'GYEONGNAM' //경상남도', //"경남"
  | 'JEJU'; // '제주특별자치도'  //"제주"

export enum JobGroupCode {
  COMMON = -1,
  MANAGEMENT = 1,
  MARKETING = 2,
  SALES = 3,
  PRODUCTION = 4,
  ENGINEER = 6,
  RESEARCH = 7,
  IT = 8,
  DESIGN = 9,
  FINANCE = 10,
  CS = 11,
  MEDICAL = 12,
}
